// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"104":"4790c98f","116":"2bf66c76","194":"1214c9bc","525":"0fb9de3b","640":"32bf63f2","645":"1214c9bc","683":"0d01c64d"}[chunkId] + ".css";
};